import Image from './dealContentType/Image';
import OptionViewDetail from './dealContentType/OptionDetailView';
import SummaryContents from './dealContentType/Summary';

function Renderer() {
  const key = TMON.oApp.htStorage.htStaticData.htDealContentInfo.contentType;
  const contentType = {
    SUMMARY: () => new SummaryContents(),
    OPTION_VIEW_DETAIL: () => new OptionViewDetail(),
    IMAGE: () => new Image(),
  };
  if (!contentType[key]) throw error('no contentType');
  else return contentType[key]();
}

export default Renderer;
